import React, { useContext, useState } from 'react';

export const PasswordlessLoginContext = React.createContext();

export const usePasswordlessLogin = () => useContext(PasswordlessLoginContext);

export const PasswordlessLoginProvider = ({ children }) => {
    
    const [detail, setDetail] = useState(null);
    const [target, setTarget] = useState("");
    const [key, setKey] = useState(null);
    const [cancelUrl, setCancelUrl] = useState("/auth/login");
    const [message, setMessage] = useState(null);

    return (
        <PasswordlessLoginContext.Provider
            value={{
                target,
                setTarget,
                key,
                setKey,
                cancelUrl,
                setCancelUrl,
                message,
                setMessage,
                detail,
                setDetail
            }}
        >
            {children}
        </PasswordlessLoginContext.Provider>
    );
};